export default __webpack_public_path__ + "static/Rectangle4387-9e60fa3d90308bdfde9d57ef321ceb5a.png";